module.exports = __webpack_public_path__ + "static/media/TSala1Alfonso Villarreal,CVeracruzano.618f65b4.pdf";